import { ref } from 'vue';
import Swal from 'sweetalert2';
import i18n from '@/i18n/index'
import { useAuthenticatedFetch } from '../auth/useAuthenticatedFetch';
import { TrainerPayment, TrainerPaymentRequest, TrainersTransactionQueryParams } from '@/interfaces/trainer';
import { trainersPayments, summary_trainersPayments, clubUUID, trainers, trainer_regulations_amount, paginationLinks } from '@/shared/state';
import { TrainerRegulationSalesQueryParams } from '@/interfaces/stats';


const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useTrainerPayment() {
    const errorTrainerPayment = ref<boolean | false>(false);
    const isRequestTrainerPayment = ref<boolean | false>(false);
    const getPayments = async (trainer_id: string) => {
        try {
            isRequestTrainerPayment.value = true
            errorTrainerPayment.value = false
            const response = await authenticatedFetch(`${API_URL}trainers-payments/${trainer_id}/${clubUUID.value}`, {
                method: 'GET'
            }, false, '', false);
            if (response?.data) {
                trainersPayments.data = response?.data || []

            }
            isRequestTrainerPayment.value = false

        } catch (err: any) {
            errorTrainerPayment.value = true;
            isRequestTrainerPayment.value = false
        }
    };


    const addPayment = async (body: TrainerPaymentRequest) => {
        try {
            isRequestTrainerPayment.value = true
            errorTrainerPayment.value = false
            const response = await authenticatedFetch(`${API_URL}trainers-payments/store`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response) {

                if (response?.data) {
                    //   trainersPayments.data = response?.data || []

                    // const index = trainers?.data?.findIndex(trainer => trainer?.id === response?.data?.trainer_id);
                    // if (index !== -1) {
                    //     trainers.data[index].remaining_amount -= response?.data?.amount_paid ?? 0;
                    //     trainers.data[index].total_amount_paid += response?.data?.amount_paid ?? 0;
                    //     if (trainers.data[index].remaining_amount <= 0)
                    //         trainers.data[index].is_paid = 1
                    // }
                }

            }
            isRequestTrainerPayment.value = false
        } catch (err: any) {
            errorTrainerPayment.value = true;
            isRequestTrainerPayment.value = false
        }
    };

    const editPayment = async (body: TrainerPaymentRequest) => {
        try {
            isRequestTrainerPayment.value = true
            errorTrainerPayment.value = false
            const response = await authenticatedFetch(`${API_URL}trainers-payments/edit/${body?.id}`, {
                method: 'PUT',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response) {
                const paymentEdited: TrainerPayment = response?.data
                const index = trainersPayments?.data?.findIndex(payment => payment?.id === paymentEdited?.id);
                if (index !== -1) {
                    trainersPayments.data[index] = paymentEdited;
                }
            }
            isRequestTrainerPayment.value = false
        } catch (err: any) {
            errorTrainerPayment.value = true;
            isRequestTrainerPayment.value = false
        }
    };


    const deletePayment = async (id: number) => {
        Swal.fire({
            title: i18n.t("message.confirmation.payment.delete.title"),
            text: i18n.t("message.confirmation.payment.delete.text"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: i18n.t("button.delete"),
            cancelButtonText: i18n.t("button.cancel"),
            allowOutsideClick: false,   // ✅ disable closing by clicking outside
                  allowEscapeKey: false       // (optional) disable closing with ESC
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    isRequestTrainerPayment.value = true
                    errorTrainerPayment.value = false
                    const response = await authenticatedFetch(`${API_URL}trainers-payments/delete/${id}`, {
                        method: 'DELETE'
                    }, true, '', true);
                    // const index = trainersPayments?.data?.findIndex(payment => payment?.id === id);
                    // if (index !== -1) {
                    //     trainersPayments.data.splice(index, 1);
                    // }
                    // isRequestTrainerPayment.value = false

                    if (response) {
                        location.reload()
                    }

                } catch (err: any) {
                    errorTrainerPayment.value = true;
                    isRequestTrainerPayment.value = false
                }
            }
        });



    };




    const fetchTrainerRegulationsStats = async (body: TrainerRegulationSalesQueryParams) => {
        try {
            isRequestTrainerPayment.value = true
            errorTrainerPayment.value = false
            trainer_regulations_amount.data = []
            const response = await authenticatedFetch(`${API_URL}trainers-payments/regulations/stats`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false, '', false);
            if (response) {

                trainer_regulations_amount.data = response?.regulations
                trainer_regulations_amount.total = response?.total
            }
            isRequestTrainerPayment.value = false
        } catch (err: any) {
            errorTrainerPayment.value = true;
            isRequestTrainerPayment.value = false
        }
    };


    const fetchTrainerTransactions = async (body: TrainersTransactionQueryParams) => {
        try {
            isRequestTrainerPayment.value = true
            errorTrainerPayment.value = false
            trainersPayments.data = []
            paginationLinks.value = 0
            const response = await authenticatedFetch(`${API_URL}trainers/transactions/search`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false, '', false);

            if (body?.type === 'paginate') {

                summary_trainersPayments.data = response?.summary || []
                trainersPayments.data = response?.transactions?.data || []
                paginationLinks.value = response?.transactions || []
                delete paginationLinks.value.data
            }
            else if (body?.type === 'all') {
                if (response?.summary) {
                    summary_trainersPayments.data = response?.summary || {}
                    trainersPayments.data = response?.transactions || {}
                } else {
                    trainersPayments.data = response || {}
                }
            }
            isRequestTrainerPayment.value = false
        } catch (err: any) {
            errorTrainerPayment.value = true;
            isRequestTrainerPayment.value = false
        }
    };

    const fetchTrainerTransactionsExportFile = async (body: TrainersTransactionQueryParams) => {
        try {
            isRequestTrainerPayment.value = true
            errorTrainerPayment.value = false
            const response = await authenticatedFetch(`${API_URL}trainers/transactions/search`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false, '', false);

            if (response) {
                isRequestTrainerPayment.value = false
                return {
                    summary_trainersPayments: response?.summary || {},
                    trainersPayments: response?.transactions || {}
                }
            }
            isRequestTrainerPayment.value = false
        } catch (err: any) {
            isRequestTrainerPayment.value = false
            errorTrainerPayment.value = true;
        }
    };

    return {
        fetchTrainerTransactions,
        fetchTrainerTransactionsExportFile,
        fetchTrainerRegulationsStats,
        getPayments,
        addPayment,
        editPayment,
        deletePayment,
        isRequestTrainerPayment,
        errorTrainerPayment
    };
}
